// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__hBa1E","content":"GlobalSearch_content__1oG0z"};